import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IDetailsPage } from "../../core/types/types";
import UpdateForm from "../GetBookingForm/GetBookingForm";
import CustomerForm from "../CustomerForm/CustomerForm";
import FormFooterButtons from "../FormFooterButtons/FormFooterButtons";

const DetailsPage: React.FC<IDetailsPage> = ({
  eventList,
  customerTicketNumber,
  updateCustomerTicketNumber,
  updateExistingBooking,
  customer,
  updateCustomer,
  isResidentialCustomer,
  updateIsResidentialCustomer,
  isValidAddress,
  updateIsValidAddress,
  hasCompletedWelcomePage,
  updateHasCompletedCustomerPage,
  isUpdatingBooking,
  updateIsUpdatingBooking,
  hasTickedPrivacyPolicy,
  updateHasTickedPrivacyPolicy,
}: IDetailsPage) => {
  const history = useHistory();
  const [isLoading, updateIsLoading] = useState<boolean>(false);
  const [detailsError, updateDetailsError] = useState<string | null>(null);
  const [isSubmitButtonDisabled, updateIsSubmitButtonDisabled] =
    useState(false);
  const [formId, updateFormId] = useState("");

  // Scroll to top when component first mounts
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  // Prevent navigation to page unless correct path was taken
  useEffect(() => {
    if (!hasCompletedWelcomePage) {
      history.replace("/");
    }
  }, [history, hasCompletedWelcomePage]);

  const cancel = () => {
    updateIsUpdatingBooking(false);
    updateHasCompletedCustomerPage(false);
    history.replace("/");
  };

  return (
    <>
      <div className="w-11/12 mx-auto">
        <div className="container mx-auto">
          <div className="mx-auto xl:w-full xl:mx-0 xl:px-12">
            <div className="mb-0 mt-12 xl:mt-20 xl:flex lg:flex md:flex flex-wrap justify-between">
              {isUpdatingBooking ? (
                <UpdateForm
                  updateFormId={updateFormId}
                  customerTicketNumber={customerTicketNumber}
                  updateExistingBooking={updateExistingBooking}
                  updateCustomerTicketNumber={updateCustomerTicketNumber}
                  customer={customer}
                  updateCustomer={updateCustomer}
                  updateHasCompletedCustomerPage={
                    updateHasCompletedCustomerPage
                  }
                  updateIsLoading={updateIsLoading}
                  updateDetailsError={updateDetailsError}
                  updateIsSubmitButtonDisabled={updateIsSubmitButtonDisabled}
                />
              ) : (
                <CustomerForm
                  eventList={eventList}
                  updateCustomerTicketNumber={updateCustomerTicketNumber}
                  customer={customer}
                  updateCustomer={updateCustomer}
                  isResidentialCustomer={isResidentialCustomer}
                  updateIsResidentialCustomer={updateIsResidentialCustomer}
                  isValidAddress={isValidAddress}
                  updateIsValidAddress={updateIsValidAddress}
                  updateHasCompletedCustomerPage={
                    updateHasCompletedCustomerPage
                  }
                  updateIsLoading={updateIsLoading}
                  updateDetailsError={updateDetailsError}
                  hasTickedPrivacyPolicy={hasTickedPrivacyPolicy}
                  updateHasTickedPrivacyPolicy={updateHasTickedPrivacyPolicy}
                  updateFormId={updateFormId}
                  updateIsSubmitButtonDisabled={updateIsSubmitButtonDisabled}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {detailsError && (
        <p className="w-full text-center body-error">{detailsError}</p>
      )}
      <FormFooterButtons
        formId={formId}
        submitButtonText="Next"
        cancelButtonText="Cancel"
        isLoading={isLoading}
        isSubmitButtonDisabled={isSubmitButtonDisabled}
        onCancelClicked={cancel}
        onSubmitClicked={() => {}}
      />
    </>
  );
};

export default DetailsPage;
